<template>
    <div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Termos de Uso</div>
            </div>
            <div class="form-group">
              <textarea 
                id="description" 
                v-model="term.description" 
                class="editor-textarea"
                placeholder="Digite os termos de uso aqui..."
              ></textarea>
            </div>
          </div>
          <hr class="m-t-lg" />
          <div class="d-flex justify-content-between mt-3">
            <button type="button" class="btn btn-info" @click="$router.go(-1)">
              <i class="fa fa-arrow-left"></i> Voltar
            </button>
            <a class="btn btn-success" @click="save">
              Salvar &nbsp;
              <i class="fa fa-save"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        term: {
          description: "",
        },
      };
    },
    methods: {
      getTermsOfUse() {
        const api = this.$store.state.api + "termsOfUses/latest";
        axios
          .get(api)
          .then((response) => {
            if (response.data[0]) {
              this.term = response.data[0];
            }
          })
          .catch(() => {
            this.$message(null, "Não foi possível encontrar o termo de uso", "error");
          });
      },
      save() {
        const api = this.$store.state.api + "termsofuses";
        axios
          .post(api, this.term)
          .then(() => {
            this.$message(null, "Registro criado com sucesso", "success");
          })
          .catch((error) => {
            this.$error(error);
          });
      },
    },
    mounted() {
      this.getTermsOfUse();
    },
  };
  </script>
  
  <style scoped>
  .editor-textarea {
    width: 100%;
    height: 300px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1.5;
    resize: vertical;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/TermsOfUse/TermsOfUse.vue